import sal from "sal.js"

sal({threshold: 0.33,});
